module.exports = __webpack_public_path__ + "static/img/h3-6.bc99bb7.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/aboutUs/h3-6.png
// module id = oAhY
// module chunks = 1